import { render, staticRenderFns } from "./AttachmentPreview.vue?vue&type=template&id=4955509a&"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js&"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports